// TANGRAM_BASE_V1 — IMMUTABLE CANONICAL GEOMETRY.
// Do not modify polygon coordinates.
// All future visual, content, animation, hover, responsive, and interaction changes must preserve these exact points.
// Single source of truth: imported by the Lobby (Dashboard) and the global TangramIcon.
export const TANGRAM_BASE_V1 = {
  s1: "0,0 1000,0 500,500",
  s2: "0,0 0,1000 500,500",
  s3: "1000,0 1000,500 750,250",
  s4: "500,500 750,250 1000,500 750,750",
  s5: "500,500 250,750 750,750",
  s6: "0,1000 250,750 750,750 500,1000",
  s7: "1000,500 1000,1000 500,1000",
};

// Piece colors (visual only — not geometry).
export const TANGRAM_COLORS = {
  s1: "#F5B841",
  s2: "#1FA9A3",
  s3: "#46B15D",
  s4: "#3B82F6",
  s5: "#2E9E5B",
  s6: "#8B5CF6",
  s7: "#F97316",
};
